function parent(element: HTMLElement, selector?: string): HTMLElement | null {
    const parentElement = element.parentElement;

    if (!parentElement) {
        return null;
    }

    if (selector != null) {
        return parentElement.matches(selector) ? parentElement : null;
    }

    return parentElement;
}

// ----------------------------------------------------------------------------

export default parent;
